import { css, styled } from '@lokalise/styled';

import { modifier, spacing, value } from '@app/theme';

export const MenuItem = styled.div<{ selected: boolean; disabled: boolean }>`
    text-align: left;
    width: 100%;
    background-color: ${value('color.background.surface.default')};
    padding: ${spacing(3)};
    color: ${value('color.text.default')};
    cursor: pointer;
    fill: ${value('color.text.default')};

    &:hover:not([disabled]):not(:focus) {
        color: ${value('color.text.default')};
    }

    &:focus,
    &:hover:not([disabled]):not([data-hover-disabled='true']) {
        background-color: ${value('color.background.active')};
        color: ${value('color.text.default')};
        fill: ${value('color.text.default')};
    }

    ${modifier(
        'disabled',
        css`
            pointer-events: none;
        `,
    )}

    ${modifier(
        'selected',
        css`
            background-color: ${value('color.background.active')};
            color: ${value('color.text.default')};
            fill: ${value('color.text.default')};
        `,
    )}
`;
